import { useEffect, useState } from 'react';
import styles from './LifeStagesCard.module.css';
import { ENTRY_REASONS_STATIC, getStageKey } from '../../pages/CareJourney';
// import { STAGES } from '../HealthChatBot/screens/LifeStageScreen';
export const STAGES = [
  {
    id: "adolescence",
    label: "Young Adult / Early Reproductive",
    age: "18–25 years",
    emoji: "👧",
    color: "#6366F1",
    bg: "#E0E7FF",
  },
  {
    id: "reproductive",
    label: "Reproductive Age",
    age: "26–35 years",
    emoji: "👩",
    color: "#8B5CF6",
    bg: "#F3E8FF",
  },
  {
    id: "mature-reproductive",
    label: "Mature Reproductive Stage",
    age: "36–45 years",
    emoji: "👩‍❤️‍👨",
    color: "#EC4899",
    bg: "#FCE7F3",
  },
  {
    id: "perimenopause",
    label: "Perimenopause",
    age: "46–55 years",
    emoji: "🌸",
    color: "#F59E0B",
    bg: "#FEF3C7",
  },
  {
    id: "postmenopause",
    label: "Postmenopause & Beyond",
    age: "56+ years",
    emoji: "🌟",
    color: "#10B981",
    bg: "#D1FAE5",
  },
];
const SparkleIcon = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
    <path
      d="M17 4L19.5 11.5L27 14L19.5 16.5L17 24L14.5 16.5L7 14L14.5 11.5L17 4Z"
      stroke="#7C3AED"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M7 4L13 10L7 16"
      stroke="#1E1B4B"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShieldIcon = () => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none">
    <circle cx="21" cy="21" r="21" fill="#EEF4FF" />
    <path
      d="M21 12L29 15V21C29 26 25.5 30 21 31.5C16.5 30 13 26 13 21V15L21 12Z"
      stroke="#2563EB"
      strokeWidth="1.7"
      fill="none"
    />
    <path
      d="M18.5 21L20.2 22.8L24 19"
      stroke="#2563EB"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const items = [
  {
    icon: '📅',
    title: 'Cycle & menstrual context',
  },
  {
    icon: '🤰',
    title: 'Pregnancy or fertility intent',
  },
  {
    icon: '🩺',
    title: 'Postpartum support needs',
  },
  {
    icon: '🌾',
    title: 'Menopause pathway matching',
  },
];
// utils/lifeStageUtils.js
export const getLifeStage = (ageGroup, maritalStatus = "") => {
  console.log(ageGroup, "thsi si  wt i ogt")
  if (!ageGroup) return { id: "young-adult", label: "Young Adult / Reproductive Stage" };
  console.log(ageGroup, "this is the agegrp")
  const age = parseInt(ageGroup.split("–")[0]) || 0;

  if (age <= 19) return { id: "adolescence", label: "Puberty / Adolescence" };
  if (age <= 35) return { id: "young-adult", label: "Young Adult / Reproductive Stage" };
  if (age <= 45) return { id: "mature-reproductive", label: "Mature Reproductive Stage" };
  if (age <= 55) return { id: "perimenopause", label: "Perimenopause" };
  if (age <= 64) return { id: "postmenopause", label: "Postmenopause" };
  return { id: "senior", label: "Senior / Geriatric Women’s Health" };
};
export default function LifeStageGuide() {
  const [userData, setUserData] = useState({});
  const [selectedStageId, setSelectedStageId] = useState("reproductive")

  useEffect(() => {
    const data = localStorage.getItem('patientPersona');

    if (data) {
      const parsed = JSON.parse(data);
      setUserData(parsed);
      // 🔥 Auto-detect and set current stage
      const detected = getLifeStage(parsed?.age || parsed?.age);
      setSelectedStageId(detected.id);
    }
  }, []);
  const totalInches = userData?.heightIn || 0;
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  const heightDisplay = totalInches ? `${feet}.${inches} ft` : 'Unknown';
  const lifeStage = getLifeStage(userData?.age, userData?.maritalStatus);
  const stageKey = getStageKey(userData?.age, userData?.marital || "Prefer not to say");
  const journey = ENTRY_REASONS_STATIC[stageKey] || ENTRY_REASONS_STATIC.youngAdult;
  const journeyTitle = journey?.journeyTitle || lifeStage.label;
  const stageLabel = lifeStage?.label || 'Life Stage';
  const ageLabel = userData?.age || userData?.ageGroup || 'Age not set';

  return (
    <div className={styles.wrapper}>
      {/* Hero */}
      <div className={styles.hero}>
        <div className={styles.heroLeft}>
          <div className={styles.heroMeta}>
            {/* <span className={styles.journeyBadge}>Recommended path</span> */}
            <span className={styles.lifeStageTitle}>Life Stage</span>
            <span className={styles.stageBadge}>{stageLabel}</span>

          </div>

          <div className={styles.heroTitleRow}>
            <div className={styles.sparkleWrap}>
              <SparkleIcon />
            </div>
            {/* <h1 className={` ${styles.journeyBadge}`}>{journeyTitle}</h1> */}
          </div>

          {/* <p className={styles.heroSubtitle}>
            This journey reflects your current stage and helps you find the most relevant questions and care guidance.
          </p> */}

          <div className={styles.userInfo}>
            <div className={styles.infoChip}>👩 {userData?.name || 'Guest'}</div>
            <div className={styles.infoChip}>🎂 {ageLabel}</div>
            <div className={styles.infoChip}>💍 {userData?.maritalStatus || 'Unknown'}</div>
            <div className={styles.infoChip}>📏

              {/* {userData?.heightIn ? `${userData.heightIn} in` : 'Unknown'} */}
              {heightDisplay}

            </div>
            <div className={styles.infoChip}>⚖️  {userData?.weightKg ? `${userData.weightKg} kg` : 'Unknown'}</div>
          </div>
        </div>

        <div className={styles.heroImageWrap}>
          <img
            src="/images/lifeStageImage.png"
            alt="woman"
            className={styles.heroImage}
          />
        </div>
      </div>

      <div className={styles.divider} />

      {/* Why ask */}
      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Why we ask</h2>
        <div className={styles.list}>
          {items.map((item, index) => (
            <button key={index} className={styles.card}>
              <div className={styles.cardLeft}>
                <div className={styles.iconCircle}>{item.icon}</div>

                <span className={styles.cardText}>{item.title}</span>
              </div>

              <ChevronIcon />
            </button>
          ))}
        </div>
      </div>
      {/* <div className={styles.timeline}>
        {STAGES.map((stage, i) => (
          <div key={stage.id}>
            <div
              className={[
                styles.tlItem,
                selectedStageId === stage.id
                  ? styles.tlCurrent
                  : "",
              ].join(" ")}
            >
              <div
                className={styles.tlIcon}
                style={{
                  background: stage.bg,
                }}
              >
                {stage.emoji}
              </div>

              <div className={styles.tlLabel}>
                <div
                  className={[
                    styles.tlName,
                    selectedStageId ===
                      stage.id
                      ? styles.tlNameCurrent
                      : "",
                  ].join(" ")}
                >
                  {stage.label}
                </div>

                <div className={styles.tlAge}>
                  {stage.age}
                </div>
              </div>

              {selectedStageId ===
                stage.id && (
                  <span
                    className={[
                      styles.badge,
                      styles.badgeCurrent,
                    ].join(" ")}
                  >
                    Current
                  </span>
                )}
            </div>

            {i < STAGES.length - 1 && (
              <div
                className={styles.tlConnector}
                style={{
                  background: stage.color,
                }}
              />
            )}
          </div>
        ))}
      </div> */}

      {/* Privacy */}
      <div className={styles.privacyCard}>
        <ShieldIcon />

        <p className={`ava-text-caption`}>
          Your information stays private and is never shared without your
          consent.
        </p>
      </div>
    </div>
  );
}